import { LOGGING_CONFIG } from "../config/constants.js";

/**
 * Centralized logging utility for the Custom Markup Extension
 */
export class Logger {
	constructor(module = "CustomMarkupExtension") {
		this.module = module;
		this.enabled = LOGGING_CONFIG.ENABLED;
		this.prefix = LOGGING_CONFIG.PREFIX;
	}

	/**
	 * Log an error message
	 * @param {string} message - Error message
	 * @param {*} data - Additional data to log
	 */
	error(message, data = null) {
		if (!this.enabled) return;

		const fullMessage = `${this.prefix}[${this.module}] ERROR: ${message}`;
		if (data) {
			console.error(fullMessage, data);
		} else {
			console.error(fullMessage);
		}
	}

	/**
	 * Log a warning message
	 * @param {string} message - Warning message
	 * @param {*} data - Additional data to log
	 */
	warn(message, data = null) {
		if (!this.enabled) return;

		const fullMessage = `${this.prefix}[${this.module}] WARN: ${message}`;
		if (data) {
			console.warn(fullMessage, data);
		} else {
			console.warn(fullMessage);
		}
	}

	/**
	 * Log an info message
	 * @param {string} message - Info message
	 * @param {*} data - Additional data to log
	 */
	info(message, data = null) {
		if (!this.enabled) return;

		const fullMessage = `${this.prefix}[${this.module}] INFO: ${message}`;
		if (data) {
			console.info(fullMessage, data);
		} else {
			console.info(fullMessage);
		}
	}

	/**
	 * Log a debug message
	 * @param {string} message - Debug message
	 * @param {*} data - Additional data to log
	 */
	debug(message, data = null) {
		if (!this.enabled) return;

		const fullMessage = `${this.prefix}[${this.module}] DEBUG: ${message}`;
		if (data) {
			console.debug(fullMessage, data);
		} else {
			console.debug(fullMessage);
		}
	}

	/**
	 * Create a logger for a specific module
	 * @param {string} moduleName - Name of the module
	 * @returns {Logger} New logger instance
	 */
	static createLogger(moduleName) {
		return new Logger(moduleName);
	}
}
